<template>
  <div>
    <div class="card mb-3">
      <div class="card-body pb-2">
        <div class="row g-2 align-items-end">
          <div class="col-lg-4 col-md-6">
            <label>Colaborador</label>
            <select id="esp-colab" data-placeholder="Selecione o colaborador" style="width:100%"></select>
          </div>
          <div class="col-lg-2 col-6">
            <label>De</label>
            <input type="date" v-model="pdatainicio" class="form-control">
          </div>
          <div class="col-lg-2 col-6">
            <label>Até</label>
            <input type="date" v-model="pdatafim" class="form-control">
          </div>
          <div class="col-lg-2 col-6">
            <button class="btn btn-info w-100 mb-2" @click="mtdexecutapesquisa" :disabled="carregando">
              <span v-if="carregando" class="spinner-border spinner-border-sm"></span><i v-else class="bi bi-search"></i> Gerar
            </button>
          </div>
          <div class="col-lg-2 col-6">
            <div class="dropdown mb-2">
              <button class="btn btn-outline-primary dropdown-toggle w-100" data-bs-toggle="dropdown" :disabled="!vidcolaborador">
                <i class="bi bi-printer"></i> Exportar
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li><a class="dropdown-item" href="#" @click.prevent="mtdexportar(1)"><i class="bi bi-printer"></i> Imprimir / PDF</a></li>
                <li><a class="dropdown-item" href="#" @click.prevent="mtdexportar(2)"><i class="bi bi-file-earmark-excel"></i> Excel</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="carregado" class="resumo">
      <div class="r"><span>Trabalhado</span><strong>{{ resumo.total_trabalhado }}</strong></div>
      <div class="r"><span>Previsto</span><strong>{{ resumo.total_esperado }}</strong></div>
      <div class="r ok"><span>Extras</span><strong>{{ resumo.total_extras }}</strong></div>
      <div class="r alerta"><span>Débitos</span><strong>{{ resumo.total_faltas }}</strong></div>
      <div class="r" :class="String(resumo.saldo).startsWith('-') ? 'alerta' : 'ok'"><span>Saldo</span><strong>{{ resumo.saldo }}</strong></div>
      <div class="r"><span>Noturno (reduzido)</span><strong>{{ resumo.adicional_noturno }}</strong></div>
      <div v-if="resumo.horas_feriado && resumo.horas_feriado !== '00:00'" class="r fer"><span>Em feriado</span><strong>{{ resumo.horas_feriado }}</strong></div>
      <div class="r perigo"><span>Faltas</span><strong>{{ resumo.dias_falta }} dia(s)</strong></div>
      <div class="r" :class="{ perigo: resumo.inconsistencias }"><span>Inconsistências</span><strong>{{ resumo.inconsistencias }}</strong></div>
    </div>

    <div class="card">
      <div v-if="escalas.length || jornada" class="card-header small">
        <b>Horário contratual:</b>&nbsp;
        <template v-if="escalas.length">
          <span v-for="(e, i) in escalas" :key="i" class="d-block d-md-inline">
            <span v-if="i" class="d-none d-md-inline"> · </span>
            <template v-if="e.desde">a partir de {{ dataBR(e.desde) }}: </template><b>{{ e.nome }}</b> ({{ e.descricao }})
          </span>
        </template>
        <template v-else>{{ jornada.nome }} ({{ jornada.descricao }})</template>
        <router-link v-if="vidcolaborador" :to="'/escalas?colaborador=' + vidcolaborador" class="ms-2 text-nowrap">
          <i class="bi bi-calendar-week"></i> ver escala
        </router-link>
      </div>
      <div class="table-responsive">
        <table class="table table-sm table-hover align-middle mb-0 espelho">
          <thead>
            <tr><th>Data</th><th>Dia</th><th>Previsto</th><th>Marcações</th><th>Jornada</th><th>Noturno</th><th>Saldo</th><th>Ocorrências</th></tr>
          </thead>
          <tbody>
            <tr v-if="!lstespelho.length"><td colspan="8" class="text-center text-muted py-4">Selecione colaborador e período e clique em Gerar.</td></tr>
            <tr v-for="(d, i) in lstespelho" :key="i" :class="{ falta: d.falta, dsr: !d.util && !d.marcacoes.length, futuro: d.futuro }">
              <td class="text-nowrap">{{ d.data }}</td>
              <td>{{ d.dia.substring(0, 3) }}</td>
              <td class="prev" :class="{ exc: d.excecao }" :title="d.posicao ? 'Escala: ' + d.posicao : ''">
                {{ d.horario || '—' }}<i v-if="d.excecao" class="bi bi-pencil-fill ms-1" :title="'Exceção: ' + d.excecao.motivo"></i>
              </td>
              <td>
                <span v-for="(m, j) in d.marcacoes" :key="j" :class="['marc', { trat: m.fonte !== 'O' }]" :title="m.fonte === 'I' ? 'Incluída: ' + m.motivo : (m.nsr ? 'NSR ' + m.nsr : '')">
                  <small>{{ m.es }}{{ m.seq }}</small> {{ m.hora }}<i v-if="m.fonte === 'I'" class="bi bi-pencil-fill"></i>
                </span>
                <span v-for="(m, j) in d.desconsideradas" :key="'d' + j" class="marc desc" :title="'Desconsiderada: ' + (m.motivo || '')">{{ m.hora }}</span>
                <span v-if="!d.marcacoes.length && !d.desconsideradas.length" class="text-muted">—</span>
              </td>
              <td class="num">{{ d.totaldia }}</td>
              <td class="num">{{ d.noturno }}</td>
              <td class="num" :class="{ neg: String(d.saldo).startsWith('-'), pos: String(d.saldo).startsWith('+') }">{{ d.futuro ? '' : d.saldo }}</td>
              <td class="obs">{{ d.obs }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer small text-muted">
        E/S = entrada/saída do par (a sequência independe do tipo informado na marcação).
        <span class="marc trat ms-1">azul</span> incluída pelo RH ·
        <span class="marc desc">riscada</span> desconsiderada.
      </div>
    </div>
  </div>
</template>

<script>
//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);
import util from '../../util.js'

function iso(d) { return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().substring(0, 10) }

export default {
  name: 'RelEspelhodePonto',
  data() {
    const h = new Date()
    return {
      pdatainicio: iso(new Date(h.getFullYear(), h.getMonth(), 1)),
      pdatafim: iso(h),
      vidcolaborador: null,
      lstespelho: [],
      resumo: {},
      jornada: null,
      escalas: [],
      carregando: false,
      carregado: false,
    }
  },
  methods: {
    dataBR(v) { return util.dataBR(v) },
    hhmm(min) { return String(Math.floor(min / 60)).padStart(2, '0') + ':' + String(min % 60).padStart(2, '0') },
    validar() {
      if (!this.vidcolaborador) { util.notif('error', 'Atenção', 'Selecione um colaborador.'); return false }
      if (!this.pdatainicio || !this.pdatafim || this.pdatainicio > this.pdatafim) { util.notif('error', 'Atenção', 'Informe um período válido.'); return false }
      return true
    },
    mtdexportar(tipo) {
      if (!this.validar()) return
      window.open(util.urlComToken('/controller/relatorios.php', {
        op: 'relatorioespelhoponto', idcolaborador: this.vidcolaborador,
        datainicio: this.pdatainicio, datafim: this.pdatafim, exportar: tipo,
      }), '_blank')
    },
    async mtdexecutapesquisa() {
      if (!this.validar()) return
      this.carregando = true
      try {
        const r = await util.reqaxios([
          { parametro: 'op', valor: 'relatorioespelhoponto' },
          { parametro: 'idempresa', valor: this.$store.state.usuario.idempresa },
          { parametro: 'idcolaborador', valor: this.vidcolaborador },
          { parametro: 'datainicio', valor: this.pdatainicio },
          { parametro: 'datafim', valor: this.pdatafim },
        ], 'post', util.servidor + '/controller/relatorios.php')
        if (!r.data || !r.data.registros) return util.respostaOk(r.data)
        this.lstespelho = r.data.registros
        this.resumo = r.data.resumo
        this.jornada = r.data.jornada
        this.escalas = r.data.escalas || []
        this.carregado = true
      } finally {
        this.carregando = false
      }
    },
  },
  mounted() {
    const vself = this
    $('#esp-colab').select2({
      ajax: {
        url: util.servidor + '/controller/select2sql.php',
        dataType: 'json',
        delay: 250,
        data: (params) => ({ q: params.term, idempresa: vself.$store.state.usuario.idempresa, tabela: 'tbcolaboradores' }),
        processResults: (data) => ({ results: data }),
      },
      minimumInputLength: 0,
      theme: 'bootstrap',
    }).on('change', function () { vself.vidcolaborador = $(this).val() })
  },
  beforeUnmount() {
    if ($('#esp-colab').data('select2')) $('#esp-colab').select2('destroy')
  },
}
</script>

<style scoped lang="scss">
.resumo { display: grid; grid-template-columns: repeat(auto-fit, minmax(118px, 1fr)); gap: 10px; margin-bottom: 14px; }
.r { background: #fff; border-radius: 12px; box-shadow: var(--ck-sombra); padding: 10px 14px; border-left: 4px solid var(--ck-borda); }
.r span { display: block; font-size: .72rem; color: var(--ck-texto-2); font-weight: 600; text-transform: uppercase; letter-spacing: .04em; }
.r strong { font-size: 1.25rem; font-variant-numeric: tabular-nums; }
.r.ok { border-left-color: var(--ck-sucesso); } .r.fer { border-left-color: #7b5fd1; } .r.alerta { border-left-color: var(--ck-alerta); } .r.perigo { border-left-color: var(--ck-perigo); }
.espelho th { font-size: .72rem; text-transform: uppercase; color: var(--ck-texto-2); background: #f7faf9; letter-spacing: .04em; }
.espelho td { font-size: .85rem; }
.espelho tr.falta td { background: #fdf1ef; }
.espelho tr.dsr td, .espelho tr.futuro td { color: #93a29d; }
.num { font-variant-numeric: tabular-nums; white-space: nowrap; }
.neg { color: var(--ck-perigo); } .pos { color: var(--ck-sucesso); }
.marc { display: inline-block; background: #f1f5f4; border-radius: 6px; padding: 2px 7px; margin: 1px 4px 1px 0; font-variant-numeric: tabular-nums; white-space: nowrap; }
.marc small { color: var(--ck-texto-2); font-weight: 700; font-size: .68rem; }
.marc.trat { background: #e2eefa; color: #24578c; }
.marc.trat i { font-size: .6rem; margin-left: 3px; }
.marc.desc { background: #fbe9e7; color: #a33; text-decoration: line-through; }
.prev { font-size: .78rem; color: var(--ck-texto-2); white-space: nowrap; font-variant-numeric: tabular-nums; }
.prev.exc { color: #8a5a00; font-weight: 600; }
.prev i { font-size: .62rem; }
.obs { font-size: .78rem; color: var(--ck-texto-2); max-width: 280px; }
</style>
